import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: white;
  width: 100%;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 20px;
  padding-left: 48px;
  padding-right: 48px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding-top: 80px;
    padding-bottom: 60px;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
`;

export const FirstSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  align-items: stretch;
  gap: 8px;
  overflow: hidden;
  padding: 8px;
  border-radius: 32px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding-top: 329px;
  }

  &::before {
    content: "";
    background-image: url(/images/backgrounds/waitlist-bg.webp);
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-position: center;

    @media ${({ theme }) => theme.media.mobile} {
      right: -40%;
      top: -489px;
      width: 200%;
      height: 200%;
      background-position: 76.4% 10.3%;
      transform: scale(0.6);
    }
  }
`;

export const ContentBox = styled.div`
  position: relative;
  background-color: white;
  z-index: 1;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 32px;
  border-radius: 24px;

  @media (min-width: 778px) {
    width: 656px;
  }

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding: 12px;
  }
`;

export const Heading = styled.h2`
  color: rgba(29, 29, 29, 0.85);
  font-size: 44px;
  font-weight: 500;
  line-height: 1.3em;
  letter-spacing: -0.02em;
  z-index: 0;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    font-size: 28px;
    letter-spacing: unset;
    padding: 8px;
  }
`;

export const HeadingSpan = styled.span`
  color: rgba(29, 29, 29, 0.5);
`;

export const SeparatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 0 24px;
  margin: 17px 0 19px;

  @media ${({ theme }) => theme.media.mobile} {
    margin: 12px 0;
  }
`;

export const SeparatorDot = styled.div`
  width: 7px;
  height: 7px;
  background-color: rgba(29, 29, 29, 0.85);
  border-radius: 50%;
`;

export const SeparatorLine = styled.div`
  margin-left: -1px;
  width: 2px;
  height: 90px;
  background-image: url(/images/icons/dashed-line-v.svg);

  @media ${({ theme }) => theme.media.mobile} {
    height: 40px;
  }
`;

export const WaitlistBox = styled.div`
  border: 1px solid rgba(29, 29, 29, 0.1);
  z-index: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding: 32px 24px 24px;
  border-radius: 24px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding: 20px;
  }
`;

export const WaitlistHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  font-size: 20px;
  color: #1d1d1dd9;
  font-weight: 500;
  line-height: 1.5em;
  justify-content: flex-start;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 16px;
    flex-direction: row;
    gap: 15px;
  }
`;

export const WaitlistIcon = styled.img`
  aspect-ratio: 1.02;
  object-fit: contain;
  width: 64px;
  height: 51px;
  align-self: stretch;
  margin: auto 0;

  @media ${({ theme }) => theme.media.mobile} {
    width: 44px;
    height: 35px;
  }
`;

export const WaitlistText = styled.div`
  align-self: stretch;
  margin: auto 0;
`;

export const TextHighlight = styled.span`
  display: block;
  color: #ff6030;
`;

export const EmailInputWrapper = styled.div`
  margin-top: 32px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
  }
`;
